<template>
    <v-container>
        <v-row>
            <v-col align="left">
                <v-img :src="require('@/assets/gifiqr-kontakt-os.jpg')"/>
                <h1>Kontakt os</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="6" align="left">
                <ContactForm/>
            </v-col>
            <v-col md="6">
                <TryGofiqr/>
                <iframe class="mt-10" width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=12.533278763294222%2C55.68118064117461%2C12.536725401878359%2C55.68243576559232&amp;layer=mapnik&amp;marker=55.68180820841828%2C12.535003423690796" style="border: 1px solid black"></iframe><br/><small><a href="https://www.openstreetmap.org/?mlat=55.68181&amp;mlon=12.53500#map=19/55.68181/12.53500&amp;layers=N">View Larger Map</a></small>
            </v-col>
        </v-row>
        <v-row>
            <v-img :src="require('@/assets/gofiqr-del-din-viden.png')"/>
        </v-row>
    </v-container>
</template>

<script>
    import ContactForm from "@/components/ContactForm";
    import TryGofiqr from "@/components/TryGofiqr";
    export default {
        name: "ContactPage",
        components: {TryGofiqr, ContactForm}
    }
</script>

<style scoped>

</style>